import { Icon } from '@iconify/react'
import { useEffect, useState } from 'react'

export default function SensitiveEmailInput({
    placeholder,
    onValidEmailChange,
    className = '',
    style = {},
    onChange = () => { },
}) {
    const [email, setEmail] = useState('')
    const [showModal, setShowModal] = useState(false)

    const isSensitiveEmail = (email) => {
        const pattern = /@(?:[\w-]*\.)?(gov|gouv|mil|int|mod\.uk|defense\.gov|state\.gov|gc\.ca|usmc\.mil|army\.mil|navy\.mil|af\.mil|gov\.(?:cn|hk|mo|tw|uk|au)|gc\.ca|nato\.int)(?:\.[a-z]{2,})?$/i

        return pattern.test(email)
    }

    // 防抖处理2500
    useEffect(() => {
        const timer = setTimeout(() => {
            if (email && isSensitiveEmail(email)) {
                setShowModal(true)
                onValidEmailChange?.('')
            } else {
                onValidEmailChange?.(email)
            }
        }, 2500)

        // return
        return () => clearTimeout(timer)
    }, [email, onValidEmailChange])


    // 输入变化处理
    const handleChange = (e) => {
        const value = e.target.value
        setEmail(value)
        onChange(e) // 调用外部的 onChange
    }

    // 失焦时立即检测
    const handleBlur = () => {
        if (email && isSensitiveEmail(email)) {
            setShowModal(true)
            onValidEmailChange?.('')
        }
    }

    const handleCloseModal = () => {
        setShowModal(false)
        setEmail('')
        onValidEmailChange?.('')
    }

    return (
        <>
            <input
                type="email"
                autoComplete="email"
                className={className}
                style={style}
                value={email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={placeholder || 'Enter your email'}
            />

            {showModal && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
                    <div className="bg-white w-[90%] max-w-[680px] p-[30px] pt-[36px] rounded-xl shadow-lg">
                        <div className="flex items-center mb-[20px]">
                            <Icon icon="noto-v1:warning" width="50" height="50" />
                            <div className="text-[32px] leading-[45px] pl-[16px]">Warning</div>
                        </div>
                        <h2 className="text-[16px] leading-[28px] mb-[12px] text-gray-800">
                            The use of government-affiliated email addresses (.gov, .gouv, .mil, etc.) is restricted under GDPR Article 9 as they may constitute sensitive personal data.
                        </h2>
                        <p className="text-[16px] leading-[24px] text-gray-600 mb-[30px]">
                            To proceed, please provide a personal email account.
                        </p>
                        <div className="flex justify-end items-end pb-[16px]">
                            <button
                                className="bg-[#259cff] text-[#fff] px-6 py-2 rounded-[8px] font-semibold hover:bg-[#4bbff5] transition"
                                onClick={handleCloseModal}
                            >
                                I Understand
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
